import Vue from "vue";

import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "../scss/main.scss";
import "../scss/colors.scss";
import "../scss/utilities.scss";

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
